import React from 'react'
import { Attachment } from '@/checkout-instore-legacy/product/typings'

import { SubmitProps } from './AttachmentForm'
import { StepperProvider } from './provider/StepperProvider'
import { MultipleAttachments } from './MultipleAttachments'
import { SingleAttachments } from './SingleAttachment'

export interface AttachmentModalBaseProps {
  isOpen?: boolean
  onSubmit: (formsValues: SubmitProps[]) => void
  onClose?: () => void
}

interface AttachmentModalProps extends AttachmentModalBaseProps {
  attachments: Attachment[]
}

export const AttachmentModal = (props: AttachmentModalProps) => {
  const { attachments } = props

  if (attachments.length > 1) {
    return (
      <StepperProvider>
        <MultipleAttachments {...props} />
      </StepperProvider>
    )
  }

  const singleAttachmentProps = { ...props, attachment: attachments[0] }

  return <SingleAttachments {...singleAttachmentProps} />
}
